import { ActionTypes } from "../../action-type";

const initialState = {
    data:null,
    action:null
};

export const topicReducer = (state=initialState,action)=>{
    switch(action.type){
        case ActionTypes.TOPICS:
            return {...state,
                data:action.payload.data,
                action:action.payload.action
            }
        default:
            return state;
    }
}
